import React, { useEffect } from 'react';
import './domains.scss';
import { useStores } from '../../../store';
import { observer } from 'mobx-react-lite';
import { InteractiveDataTable } from '../../../shared/interactive-data-table/interactive-data-table';
import { domainsColumns } from './domains-columns-config';
import { useDomainsCrudConfig } from './domains-crud-config';
import { EmptyState } from '../../../shared/empty-state/empty-state';
import { IconType } from '../../../shared/custom-icon/custom-icon';
import { BulkProtectionOptions, WebFilteringSubMenu } from '../../../../utils/enums';
import { domainsFiltersConfig } from '../../../shared/filters/filter-config/domains-filters';
import { BulkPolicyUpdate } from '../../../shared/bulk-options/bulk-policy-update';
import { StatusBadge } from '../../../shared/status-badge/status-badge';

export const Domains: React.FC = observer(() => {
    const {fwVersionStore} = useStores();
    const { getDomains, selectedFwVersion, isLoading} = fwVersionStore;
    const config = useDomainsCrudConfig();

    useEffect(() => {
        fwVersionStore.setWebFilteringType(WebFilteringSubMenu.DOMAINS);
    }, []);

    return (
        <div className="domains" data-testid="domains">
            <InteractiveDataTable filterConfig={domainsFiltersConfig}
                                  data={getDomains}
                                  columnsConfig={domainsColumns}
                                  crudConfig={config}
                                  statusBadge={<StatusBadge pageName={BulkProtectionOptions.DOMAINS}/>}
                                  emptyStateComp={
                                      <EmptyState
                                          iconType={IconType.AllowEmptyState}
                                          subTitle="To add new item click"
                                          secondarySubTitle=" Add Domain"
                                      />}
                                  dataHasLoaded={!!selectedFwVersion}
                                  isLoading={isLoading || !selectedFwVersion}
            >
                <BulkPolicyUpdate tab={BulkProtectionOptions.DOMAINS}/>
            </InteractiveDataTable>
        </div>
    );
});